import { render, staticRenderFns } from "./product_cost_detail.vue?vue&type=template&id=e89bd992&scoped=true&"
import script from "./product_cost_detail.vue?vue&type=script&lang=js&"
export * from "./product_cost_detail.vue?vue&type=script&lang=js&"
import style0 from "./product_cost_detail.vue?vue&type=style&index=0&id=e89bd992&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89bd992",
  null
  
)

export default component.exports